import { render, staticRenderFns } from "./RowItemDocument.vue?vue&type=template&id=769fff20&scoped=true"
import script from "./RowItemDocument.vue?vue&type=script&lang=js"
export * from "./RowItemDocument.vue?vue&type=script&lang=js"
import style0 from "./RowItemDocument.vue?vue&type=style&index=0&id=769fff20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "769fff20",
  null
  
)

export default component.exports